<template>
  <div>
    <h1>Manage Client Databases</h1>
    <div class="mt-5">
      <client-database-table :table-items="clientDatabaseList" />
    </div>
  </div>
</template>

<script>
import ClientDatabaseTable from '@/components/manageClients/ClientDatabaseTable'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'manage-client-databases',
  components: {
    ClientDatabaseTable
  },
  computed: {
    ...mapState('manageClient', ['clientDatabaseList'])
  },
  created() {
    this.getClientDatabaseDetails()
  },
  methods: {
    ...mapActions('manageClient', ['getClientDatabaseDetails'])
  }
}
</script>
